import { TranslationKeys } from '~frontend-common/i18n/english/confirmation-form.i18n';

const keys: TranslationKeys = {
  confirmation: {
    fieldsTitles: {
      carVins: "Numéro d'identification du véhicule (NIV)",
      coInsured: {
        birthday: 'Date de naissance',
        firstName: 'Prénom',
        lastName: ' Nom de famille',
        occupation: 'Emploi',
        relationship: 'Relation',
        school: "Nom de l'établissement d'étude",
        workplace: 'Employeur',
      },
      homeCreditor: {
        name: 'Nom du créancier hypothécaire',
        address: 'Adresse du créancier hypothécaire',
      },
      effectiveDate: 'Date effective',
      licenceNumbers: 'Numéro du permis de conduire',
      school: "Nom de l'établissement d'étude",
      workplace: 'Employeur',
    },
    helpers: {
      mobileAppTracking: {
        intact: {
          title: "Application Ma Conduite d'Intact",
          description:
            "Cette police fait partie du programme Ma conduite et vous aide à être récompensé pour vos bonnes habitudes au volant.<0></0><0></0> Obtenez automatiquement un rabais d’adhésion de 10% lors de votre inscription à Ma Conduite. Afin de conserver votre rabais, vous devez installer l'application mobile d'Intact et activer l'option Ma conduite et vous devez utiliser l'application continuellement. Si l'application mobile n'est pas utilisée, vous perdrez votre rabais.<0></0><0></0> Le rabais sera ensuite ajusté chaque année en fonction de votre conduite et pourrait atteindre jusqu’à 25%.<0></0><0></0> Vous allez recevoir un courriel d’Intact avec tous les détails pour installer l’application dans les jours suivant l’achat de votre police. Vous pouvez vous désinscrire du programme Ma Conduite à tout moment.",
        },
        travelers: {
          title: 'Application IntelliDrive de Travelers',
          description:
            'Cette police fait partie du programme IntelliDrive et vous permet d’être récompensé pour vos bonnes habitudes de conduite.<0></0>Vous bénéficiez automatiquement d’un rabais de 2,5 % lors de votre inscription à IntelliDrive.<0></0><0></0>Pour conserver votre rabais, vous devez installer l’application mobile Travelers, activer l’option IntelliDrive et utiliser l’application pour enregistrer vos données de conduite pendant une période d’évaluation de 90 jours. Vous devez parcourir au moins 800 km pendant ces 90 jours pour compléter l’évaluation. Vos habitudes de conduite seront évaluées, et si elles sont jugées sécuritaires, vous pourriez obtenir jusqu’à 30 % de rabais lors du renouvellement de votre police.<0></0><0></0>Vous allez recevoir un courriel de Travelers avec tous les détails pour installer l’application dans les jours suivant l’achat de votre police. Vous pouvez vous désinscrire du programme IntelliDrive en tout moment.',
        },
      },
      carVin: {
        description:
          "Vous pouvez trouver le numéro d'identification de votre véhicule (NIV) sur votre certificat d'immatriculation. Le NIV est un code unique composé de 17 caractères.",
        title: "Où trouver le numéro d'identification (NIV) du véhicule?",
      },
      coInsured: {
        condo: {
          title: 'Est-ce que le condo a un autre propriétaire?',
          subtitle:
            "Une personne est propriétaire si son nom est sur le registre foncier. Cette personne, considérée comme co-assurée, peut agir en votre nom pour modifier ou résilier la police d'assurance.",
        },
        homeowner: {
          title: 'Est-ce que la maison a un autre propriétaire?',
          subtitle:
            "Une personne est propriétaire si son nom est sur le registre foncier. Cette personne, considérée comme co-assurée, peut agir en votre nom pour modifier ou résilier la police d'assurance.",
        },
        tenant: {
          title: 'Aimeriez-vous ajouter quelqu’un qui vit avec vous en tant que co-assuré?',
          subtitle:
            "Un co-assuré peut agir en votre nom pour modifier ou résilier la police d'assurance. Toute personne liée par le sang est automatiquement couverte et n'a pas besoin d'être ajoutée comme co-assurée. <0></0><1></1> Important: Les limites de couverture sélectionnées doivent être suffisantes pour couvrir tout le monde sur le contrat.",
        },
      },
      licenceNumber: {
        description: {
          on: "Le numéro de permis de conduire est indiqué dans le haut du permis de conduire. Il est composé de 15 caractères et débute par la première lettre du nom de famille. Si votre permis de conduire n'est pas de l'Ontario, contactez-nous à contact@youset.ca ou 514-613-6267.",
          qc: "Le numéro de permis de conduire est indiqué dans le haut du permis de conduire. Il est composé de 13 caractères et débute par la première lettre du nom de famille. Si votre permis de conduire n'est pas du Québec, contactez-nous à contact@youset.ca ou 514-613-6267.",
        },
        title: 'Où trouver le numéro de permis de conduire?',
      },
    },
    placeholders: {
      coInsuredOccupation: 'ex. Génie et sciences',
      coInsuredRelationship: 'Colocataire',
      coInsuredWorkplace: 'ex. Starbucks',
      homeCreditor: {
        name: 'ex. Banque Nationale',
        address: 'ex. 500 René-Lévesque Ouest, Montréal',
      },
      licenceNumbers: {
        on: 'ex. L1234-12345-12345',
        qc: 'ex. L1234-120380-00',
      },
      occupation: 'ex. Génie et sciences',
      workplace: 'ex. Starbucks',
    },
    prompts: {
      common: {
        footer: {
          buttons: {
            next: 'Suivant',
            recalculate: 'Oui',
            reject: 'Non',
          },
          recalculate: 'Voulez-vous appliquer les changements dans la soumission et recalculer la prime?',
        },
      },
      invalidReconstructionCost: {
        body: 'Nous avons estimé que la valeur de reconstruction de votre maison est de {{0}}. Nous recommandons que la couverture de votre maison soit au minimum {{0}}.',
        header: {
          mainTitle: 'Important!',
          subtitle: 'La couverture de votre maison est insuffisante.',
        },
        reconstructionCost: 'Couverture de la maison choisie',
      },
      invalidVin: {
        carDescriptionSelector: {
          description:
            'Le numéro d’identification du véhicule (NIV) fourni ne correspond pas à votre voiture {{0}}. Sélectionnez le modèle correspondant à votre véhicule:',
        },
        common: {
          vin: 'NIV fourni',
        },
        header: {
          mainTitle: 'NIV invalide!',
          subtitle: "Il semble y avoir un problème avec le numéro d'identification du véhicule (NIV) fourni.",
        },
        vinEditor: {
          description: 'Le NIV est invalide. Entrez un NIV valide:',
          doesNotExists: "Ce NIV n'existe pas. Veuillez réessayer.",
          placeholder: 'Entrez un nouveau NIV',
        },
      },
      carClaims: {
        header: {
          mainTitle: 'Nous avons vérifié vos déclarations',
          subtitle:
            'Nous avons constaté quelques différences en comparant les données que vous avez entrées et votre rapport DASH (Ontario Driver and Auto Search History).',
        },
        body: {
          title: "S'il vous plaît, révisez les réclamations de chaque conducteur:",
          noClaims: 'Aucune réclamation récente',
        },
      },
    },
    review: {
      subtitle: 'Révisez les détails de votre police d’assurance.',
      title: 'Sommaire de la commande',
    },
    subtitles: {
      carVins: 'Quel est le numéro d’identification (NIV) du véhicule <0>{{0}}</0> ?',
      coInsured: {
        condo:
          "Il peut s'agir de votre conjoint(e) ou de tout autre propriétaire. Tous les propriétaires de la résidence doivent être identifiés sur la police d’assurance. Pour assurer 3 propriétaires ou plus, communiquez avec nous.",
        homeowner:
          "Il peut s'agir de votre conjoint(e) ou de tout autre propriétaire. Tous les propriétaires de la résidence doivent être identifiés sur la police d’assurance. Pour assurer 3 propriétaires ou plus, communiquez avec nous.",
        tenant:
          "Un co-assuré peut agir en votre nom pour modifier ou résilier la police. Toute personne liée par le sang est automatiquement couverte et n'a pas besoin d'être ajoutée comme co-assurée.",
      },
      coInsuredSituation: 'Comment décririez-vous la personne que vous ajoutez à la police?',
      creditor: "Nous leur enverrons une copie de votre police d'assurance par la poste.",
      effectiveDate: {
        default: "On peut émettre votre police jusqu'à un maximum de {{0}} jours en avance",
        notaryDate: 'La date devrait être la date de passation chez le notaire.',
        moveInDate: "La date devrait être la date d'emménagement ou après",
      },
      licenceNumber: 'Quel est le numéro de permis de conduire de <0>{{0}}</0>?',
      main: 'Nous avons besoin de quelques informations de plus sur vous',
    },
    titles: {
      mobileAppTracking: {
        intact:
          'Pour conserver mon rabais de 10 % avec Ma Conduite, est-ce que tous les conducteurs acceptent d’installer et d’utiliser en continu l’application <0>Ma Conduite</0> d’Intact sur leur téléphone intelligent ?',
        travelers:
          'Pour conserver le rabais IntelliDrive, est-ce que tous les conducteurs acceptent d’installer et d’utiliser l’application <0>IntelliDrive</0> sur leur téléphone intelligent pendant la période d’évaluation de 90 jours ?',
      },
      carCreditors: {
        financed: 'Qui a financé le véhicule <0>{{0}}</0> et quelle est l’adresse du prêteur? ',
        leased: 'Qui a financé le véhicule <0>{{0}}</0> et quelle est l’adresse du prêteur? ',
      },
      coInsured: {
        condo: 'Est-ce que le condo a un autre propriétaire?',
        homeowner: 'Est-ce que la maison a un autre propriétaire?',
        tenant: 'Aimeriez-vous ajouter quelqu’un qui vit avec vous en tant que co-assuré?',
      },
      effectiveDate: "Quand voulez-vous que votre police d'assurance {{0}} commence?",
      main: 'Complétez votre commande',
      mortgageLenders_one: "Quel est le nom et l'adresse de votre créancier hypothécaire?",
      mortgageLenders_other: 'Quels sont les noms et adresses de vos créanciers hypothécaires?',
      school: "Quel est le nom de l'établissement scolaire que vous fréquentez?",
      work: 'Quel est le nom de la compagnie où vous travaillez?',
    },
  },
};

export default keys;
